import React from 'react';
import Skeleton from 'react-loading-skeleton'
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { selectSmallBanner } from '../../redux/small-banner/small-banner.selector';
import BannerPopUp from '../../components/banner-popup/banner-popup.components';

import './small-banner.styles.css';

class smallBanner extends React.Component {

    constructor() {
        super();
        this.state = {
            click: false,
            url: '',
        }
    }
    setcloseAction = () => {
        this.setState({ click: !this.state.click })
    }
    componentWillUnmount() {
        this.setState({ click: false, url: '' });
    }
    render() {
        const Banner = this.props.sBanner;
        if (Banner !== null) {
            return (
                <div>
                    {this.state.click === true && <BannerPopUp url={this.state.url} closeAction={this.setcloseAction} />}
                    <div className="small-banner-container uk-position-relative uk-visible-toggle uk-light" tabIndex="-1" uk-slider="finite: true;autoplay: false; autoplay-interval: 2000;pause-on-hover: true">
                        <ul className="small-banner-ul uk-slider-items uk-grid sub-banner">
                            {Banner &&
                                Banner.map((slider) => (
                                    <li key={slider.id} className="small-banner-li">
                                        <div className="uk-panel" >
                                                <img className="small-banner-img" src={slider.image_url} alt="slider" onClick={() => this.setState({ click: !this.state.click, url: slider.deeplink })} />
                                        </div>
                                    </li>
                                ))
                            }
                        </ul>
                    </div>
                </div>
            )
        } else if (Banner === null) {
            return (
                <div>
                </div>
            )
        } else {
            return (
                <div>
                    <div className="small-banner-container uk-position-relative uk-visible-toggle uk-light" tabIndex="-1" >

                        <ul className="small-banner-ul uk-slider-items uk-grid sub-banner">

                            <li className="small-banner-li">
                                <div className="uk-panel" >
                                    <Skeleton height={100} width={150} />
                                </div>

                            </li>
                            <li className="small-banner-li">
                                <div className="uk-panel" >
                                    <Skeleton height={100} width={150} />
                                </div>

                            </li>
                            <li className="small-banner-li">
                                <div className="uk-panel" >
                                    <Skeleton height={100} width={150} />
                                </div>

                            </li>
                        </ul>
                    </div>
                </div>
            )
        }
    }
}
const mapStateToProps = createStructuredSelector({
    sBanner: selectSmallBanner,
})

export default connect(mapStateToProps)(smallBanner);